import {Injectable} from '@angular/core';
import {BehaviorSubject} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class PermissionsService {

  private userPermissionsDataSource = new BehaviorSubject<any>({type: -1});

  currentUserPermissionsData = this.userPermissionsDataSource.asObservable();

  constructor() { }

  changeUserPermissionsData(data: any) {
    this.userPermissionsDataSource.next(data);
  }
}
